import { MenuTypes } from '@/models/Menu/Constants'

export const getTargetSettingRadius = campaign => {
  if (campaign.menu.menuType !== MenuTypes.Railway) {
    return campaign.menuSetting.visibleDeliveryLocationGroups
  } else {
    let responseLines = []
    campaign.menuSetting.orderDescription.target.railwayStationTargetObj.railwayCompanies.forEach(
      company => {
        const lines = company.railwayLines.map(line => {
          return {
            companyId: company.id,
            lineId: line.id,
            lineName: line.name,
            radius: line.radius,
          }
        })
        responseLines = responseLines.concat(lines)
      },
    )
    return responseLines
  }
}
